module.exports = __webpack_public_path__ + "static/media/(LH)-Artesanato-11.5f16a828.jpg";